/** Format published unit total for headlines (e.g. "48+"). */
export function formatUnitCount(count, { plus = true } = {}) {
  const total = Number(count);
  if (!Number.isFinite(total) || total <= 0) return "";
  const formatted = total.toLocaleString("en-IN");
  return plus ? `${formatted}+` : formatted;
}

/** Replace legacy hard-coded unit totals inside CMS copy. */
export function withUnitCountInText(text, count) {
  if (!text || count == null || count <= 0) return text;

  const formatted = Number(count).toLocaleString("en-IN");
  const plus = `${formatted}+`;

  return text
    .replace(/through our\s+[\d,]+\+?\s+units/gi, `through our ${plus} units`)
    .replace(/across\s+[\d,]+\+?\s+units/gi, `across ${plus} units`)
    .replace(/[\d,]+\+\s+parish-based units/gi, `${plus} parish-based units`)
    .replace(/The\s+[\d,]+\+?\s+BCS parish units/gi, `The ${plus} BCS parish units`);
}

/** Home page section title: "48+ units, one Sabha". */
export function formatUnitsSectionTitle(count) {
  const label = formatUnitCount(count);
  return label ? `${label} units, one Sabha` : "units, one Sabha";
}
